// app
export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER = 'SET_USER'

// mws
export const MWS_SET_SERVER = 'MWS_SET_SERVER'
export const MWS_SET_LOADING = 'MWS_SET_LOADING'
export const MWS_TOGGLE_COMMON_DIALOG = 'MWS_TOGGLE_COMMON_DIALOG'
export const MWS_TOGGLE_FREQ_DIALOG = 'MWS_TOGGLE_FREQ_DIALOG'
export const MWS_TOGGLE_RESTART_DIALOG = 'MWS_TOGGLE_RESTART_DIALOG'

// sn
export const SN_SET_LIST = 'SN_SET_LIST'
export const SN_SET_SN_KEY = 'SN_SET_SN_KEY'
export const SN_UPDATE_LIST_CONDITION = 'SN_UPDATE_LIST_CONDITION'
export const SN_SET_LIST_LOADING = 'SN_SET_LIST_LOADING'

// products
export const PRODUCTS_SET_LIST = 'PRODUCTS_SET_LIST'
export const PRODUCTS_SET_LIST_LOADING = 'PRODUCTS_SET_LIST_LOADING'

// gateway
export const GATEWAY_SET_LIST = 'GATEWAY_SET_LIST'
export const GATEWAY_SET_LOADING_LIST = 'GATEWAY_SET_LOADING_LIST'
export const GATEWAY_TOGGLE_COMMON_DIALOG = 'GATEWAY_TOGGLE_COMMON_DIALOG'
export const GATEWAY_TOGGLE_CONFIG_DIALOG = 'GATEWAY_TOGGLE_CONFIG_DIALOG'
export const GATEWAY_SET_PARAMS = 'GATEWAY_SET_PARAMS'
export const GATEWAY_TOGGLE_STRATEGY_DIALOG = 'GATEWAY_TOGGLE_STRATEGY_DIALOG'

// terminal
export const TERMINAL_SET_LIST = 'TERMINAL_SET_LIST'
export const TERMINAL_SET_LOADING_LIST = 'TERMINAL_SET_LOADING_LIST'
export const TERMINAL_TOGGLE_COMMON_DIALOG = 'TERMINAL_TOGGLE_COMMON_DIALOG'
export const TERMINAL_TOGGLE_CONFIG_DIALOG = 'TERMINAL_TOGGLE_CONFIG_DIALOG'
export const TERMINAL_SET_PARAMS = 'TERMINAL_SET_PARAMS'
export const TERMINAL_TOGGLE_STRATEGY_DIALOG = 'TERMINAL_TOGGLE_STRATEGY_DIALOG'

// system
export const SYSTEM_SET_LIST = 'SYSTEM_SET_LIST'
export const SYSTEM_SET_LOADING_LIST = 'SYSTEM_SET_LOADING_LIST'
export const SYSTEM_UPDATE_PARAMS = 'SYSTEM_UPDATE_PARAMS'

// user
export const USER_SET_LIST = 'USER_SET_LIST'
export const USER_SET_LOADING_LIST = 'USER_SET_LOADING_LIST'
export const USER_UPDATE_PARAMS = 'USER_UPDATE_PARAMS'

// log
export const LOG_SET_SN_LIST = 'LOG_SET_SN_LIST'
export const LOG_SET_SN_PARAMS = 'LOG_SET_SN_PARAMS'
export const LOG_SET_LOADING = 'LOG_SET_LOADING'
